import commonEn from './common/en'
import commonEs from './common/es'

/** Namespace under which both apps register the shared resources. */
export const COMMON_NAMESPACE = 'common'

/**
 * i18next-shaped resource tree ({ [language]: { [namespace]: strings } }).
 * Apps merge this into their own `resources` at init time.
 */
export const sharedI18nResources = {
  en: { common: commonEn },
  es: { common: commonEs },
} as const

/** Shape of the shared `common` namespace — use for CustomTypeOptions in each app. */
export type SharedCommonTranslations = typeof commonEn

export { commonEn, commonEs }
export type { PartialTranslations } from './common/es'
